@import "tailwindcss";

@theme inline {
  --color-background: #0B0B0B;
  --color-foreground: #F5F5F5;
  
  --color-secondary: #161616;
  --color-gold: #B68D40;
  --color-beige: #D8C3A5;

  --font-luxury: 'Cormorant Garamond', serif;
  --font-heading: var(--font-luxury);
  --font-sans: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

:root {
  --background: #0B0B0B;
  --foreground: #F5F5F5;
  --font-luxury: 'Cormorant Garamond', serif;
}

body {
  background-color: var(--background);
  color: var(--foreground);
  font-family: var(--font-sans);
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-luxury), serif;
}

/* Lenis Recommended CSS */
html.lenis, html.lenis body {
  height: auto;
}

.lenis.lenis-smooth {
  scroll-behavior: auto !important;
}

.lenis.lenis-smooth [data-lenis-prevent] {
  overscroll-behavior: contain;
}

.lenis.lenis-stopped {
  overflow: hidden;
}

.lenis.lenis-smooth iframe {
  pointer-events: none;
}

/* --- Dark/Light Mode Filter Fallback --- */
html.light {
  filter: invert(1) hue-rotate(180deg);
}
html.light img,
html.light video,
html.light iframe,
html.light [style*="background-image"] {
  filter: invert(1) hue-rotate(180deg);
}

/* --- Swiper Gold Customization --- */
.swiper-button-next,
.swiper-button-prev {
  color: var(--color-gold) !important;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 24px !important;
  font-weight: bold;
}
.swiper-pagination-bullet-active {
  background: var(--color-gold) !important;
  opacity: 1 !important;
}
.swiper-pagination-bullet {
  background: rgba(255, 255, 255, 0.6);
  opacity: 1;
}

/* --- Hide Google Translate Toolbar --- */
.goog-te-banner-frame,
.goog-te-banner-frame.skiptranslate {
  display: none !important;
  visibility: hidden !important;
}

body {
  top: 0 !important;
}

.skiptranslate {
  display: none !important;
}

/* Hide translate tooltip popup */
.goog-tooltip,
.goog-tooltip:hover {
  display: none !important;
}

.goog-text-highlight {
  background: none !important;
  box-shadow: none !important;
}
